export { WidgetsModule } from './widgets.module';

export { AlmArrayFilter } from './pipes/alm-array-filter.pipe';
export { AlmAvatarSize } from './pipes/alm-avatar-size.pipe';
export { AlmLinkTarget } from './pipes/alm-link-target.pipe';
export { AlmMomentTime } from './pipes/alm-moment-time.pipe';
export { AlmSearchHighlight } from './pipes/alm-search-highlight.pipe';
export { AlmTrim } from './pipes/alm-trim';
export { ArrayCount } from './pipes/arrayCount.pipe';

export { ContainerTogglerModule } from './container-toggler/container-toggler.module';
export { DialogModule } from './dialog/dialog.module';
export { Dialog } from './dialog/dialog';
export { DropdownModule } from './dropdown/dropdown.module';
export { DropdownOption } from './dropdown/dropdown-option';
export { AlmEditableModule } from './editable/almeditable.module';
export { AlmIconModule } from './icon/almicon.module';
export { InfiniteScrollModule } from './infinitescroll/infinitescroll.module';

// Config
export { Action } from './config/action';
export { ActionsConfig } from './config/actions-config';
export { View } from './config/view';
export { ViewsConfig } from './config/views-config';

// Markdown module
export { MarkdownComponent } from './markdown/markdown.component';
export { MarkdownModule } from './markdown/markdown.module';

// Slide-out panel
export { SlideOutPanelComponent } from './slide-out-panel/slide-out-panel.component';
export { SlideOutPanelModule } from './slide-out-panel/slide-out-panel.module';
